import {
  RETRIEVE_BLOCKED_IP_ADDRESSES,
  CREATE_BLOCKED_IP_ADDRESS,
  UNBLOCK_IP_ADDRESS,
  DELETE_BLOCKED_IP_ADDRESS,
} from "../actions/types";

const initialState = { blockedIpAddresses: [], totalBlockedIpAddressCount: 0 };

const blockedIpAddressReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RETRIEVE_BLOCKED_IP_ADDRESSES:
      return {
        blockedIpAddresses: payload.rows,
        totalBlockedIpAddressCount: payload.count,
      };

    case CREATE_BLOCKED_IP_ADDRESS:
      return state;

    case UNBLOCK_IP_ADDRESS:
      return {
        blockedIpAddresses: payload.rows,
        totalBlockedIpAddressCount: payload.count,
      };

    case DELETE_BLOCKED_IP_ADDRESS:
      return {
        blockedIpAddresses: payload.rows,
        totalBlockedIpAddressCount: payload.count,
      };

    default:
      return state;
  }
};

export default blockedIpAddressReducer;
